export default __webpack_public_path__ + "static/lefafa_1_2-79468e5a07fe6024f9898be7c8b878f7.webp";